import { createAction } from 'typesafe-actions';

import { Toast } from './types';

export const pushToast = createAction('TOAST_PUSHED')<Toast>();
export const dismissToast = createAction('TOAST_DISMISSED')<string>();
